module.exports = __webpack_public_path__ + "img/35-Dry.3e3adf08.png";